import { LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import {
  STORE_MAP_CONFIGURATION_STORE,
  StoreMapConfigurationStore
} from 'components/discovery/store-locator/components/store-map/store-map-config-store.js'
import {
  COORDINATE_TYPE_ZOOM,
  CSMapZoomConfiguration,
  InitialCoordinates
} from 'components/discovery/store-locator/typing/internal.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { STORE_LOCATOR_STORE, StoreLocatorStore } from 'components/discovery/store-locator/store-locator-store.js'

@customElement('csc-store-map-configurator')
export class CSCStoreMapConfigurator extends LitElement {

  @inject(STORE_MAP_CONFIGURATION_STORE)
  mapConfigStore!: StoreMapConfigurationStore

  @inject(STORE_LOCATOR_STORE)
  storeLocatorStore!: StoreLocatorStore

  @property({ type: Object, attribute: 'zoom' })
  zoom: CSMapZoomConfiguration = COORDINATE_TYPE_ZOOM

  @property({ type: String, attribute: 'maps-key' })
  mapsApiKey = ''

  @property({ type: String, attribute: 'custom-marker' })
  marker: string | null = null

  @property({ type: Array, attribute: 'initial-coordinates' })
  initialCoordinates: InitialCoordinates | null = null

  override connectedCallback() {
    super.connectedCallback()

    this.mapConfigStore.setZoomConfig(this.zoom)

    this.mapConfigStore.setMapsApiKey(this.mapsApiKey)

    if (this.marker) {
      this.mapConfigStore.setMarker(this.marker)
    }

    if (this.initialCoordinates) {
      this.storeLocatorStore.preloadCoordinates({
        type: 'initial',
        location: {
          latitude: this.initialCoordinates[0],
          longitude: this.initialCoordinates[1],
        }
      })
    }
  }

  override render() {
    return nothing
  }
}
